import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';
import { OrderErrorCode } from '@/models';

@Component({
  name: 'CmgOrderConfirmationCancelOrderFailureModal',
})
export default class CmgOrderConfirmationCancelOrderFailureModal extends Vue {
  get visible(): boolean {
    return this.$appStore.state.ui.modals.postSubmitCancelOrderFailure.visible;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get headingText(): string {
    return this.$appStore.state.ui.modals.postSubmitCancelOrderFailure.args?.errorCode === OrderErrorCode.OrderNotEligibleForCancellation ?
      'AW SHUCKS'
      :
      'WE\'RE SORRY'
  }

  get subheadingText(): string {
    return this.$appStore.state.ui.modals.postSubmitCancelOrderFailure.args?.errorCode === OrderErrorCode.OrderNotEligibleForCancellation ?
      'We’re no longer able to cancel your order because the cancellation period has closed.'
      :
      'Due to technical issues, we’re no longer able to cancel your order. Please chat with Pepper at this time.'
  }

  close(): void {
    this.$services.ui.setModalVisibility('postSubmitCancelOrderFailure', false, { errorCode: '' });
    this.$services.ui.focusBack();
  }
}
